<ngx-extended-pdf-viewer *ngIf="data.pdf" [base64Src]="data.pdf" enablePrintAutoRotate="true"  [printResolution]="300"
 [showUnverifiedSignatures]="false" [showHandToolButton]="true" useBrowserLocale="true" height="100%" [zoom]="'page-width'">
</ngx-extended-pdf-viewer>
